import { FC, useState } from 'react';
import { Box, Chip, TextField, Typography } from '@mui/material';
import { representationSchemeType } from 'services/constants/representationSchemeType';
import { AmountWithQuantity } from 'components/Order/OrderDiscounts/OrderDiscountsItem/AmountWithQuantity';
import { TCreateDiscountItemProps } from './types';
import { EasChip } from 'ui/EasChip';
import { COLORS } from 'services/constants/colors';

export const CreateDiscountItem: FC<TCreateDiscountItemProps> = ({
	createDiscountItem,
	returnItemQuantity,
	discount,
	value,
	setValue,
	paymentCurrency,
	setSelectedCurrency,
	selectedCurrency,
}) => {
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (selectedCurrency === '%') {
			if (Number(event.target.value) > 100) {
				setValue('100');
				return;
			}
		} else if (Number(event.target.value) > createDiscountItem.itemCostIncludingVat) {
			setValue(`${createDiscountItem.itemCostIncludingVat}`);
			return;
		}
		if (Number(event.target.value) < 0) {
			setValue('0');
			return;
		}
		setValue(event.target.value);
	};

	const handleBlur = () => {
		if (value === '') {
			setValue('0');
		}
	};

	const currencies = ['%', paymentCurrency];
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				// alignItems: 'center',
				mb: 1,
				opacity:
					createDiscountItem.previousDiscounts || createDiscountItem.previousReturns ? '.5' : '1',
				'&:hover': { backgroundColor: '#f5f5f5' },
			}}
		>
			<Box
				key={createDiscountItem.id}
				sx={{
					display: 'flex',
					flexDirection: 'row',
					gap: 1,
					mr: 4,
				}}
			>
				{' '}
				<Typography
					variant="body2"
					sx={{
						fontWeight: 'bold',
					}}
					color="primary"
				>
					{representationSchemeType?.[
						createDiscountItem.scheme as keyof typeof representationSchemeType
					] ?? createDiscountItem.scheme}
				</Typography>
				<Typography variant="body2">
					<span style={{ fontWeight: 'bold' }}>{createDiscountItem.idProvidedByEm} — </span>
					{createDiscountItem.shortDescription}
				</Typography>
				{!!returnItemQuantity && (
					<EasChip label={`${String(returnItemQuantity)} returned`} bgcolor={COLORS.RETURNED} />
				)}
				{discount && <EasChip label={`-${discount.toFixed(1)} %`} bgcolor={COLORS.DISCOUNT} />}
			</Box>
			<Box sx={{ display: 'flex', gap: 1 }}>
				<AmountWithQuantity
					name=" "
					amount={createDiscountItem.costProvidedByEm}
					quantity={createDiscountItem.quantity}
					paymentCurrency={paymentCurrency}
				/>
				{/* <Typography variant="body2" sx={{ mr: 1 }}>
					{createDiscountItem.costProvidedByEm.toFixed(2)}{' '}
					<span
						style={{
							fontSize: '.7rem',
							color: '#00000080',
							fontWeight: 'normal',
						}}
					>
						{paymentCurrency}
					</span>{' '}
					x {createDiscountItem.quantity} = {createDiscountItem.itemCostIncludingVat.toFixed(2)}{' '}
					<span
						style={{
							fontSize: '.7rem',
							color: '#00000080',
							fontWeight: 'normal',
						}}
					>
						{paymentCurrency}
					</span>
				</Typography> */}
				{/* {!createDiscountItem.previousDiscounts && !createDiscountItem.previousReturns && ( */}
				<>
					<TextField
						size="small"
						variant="outlined"
						type="number"
						sx={{
							width: '70px',

							'& input': {
								textAlign: 'center',
								height: '20px',
								padding: '2px 0',
							},
						}}
						disabled={createDiscountItem.previousDiscounts || createDiscountItem.previousReturns}
						value={value}
						onChange={handleChange}
						onBlur={handleBlur}
					/>
					<TextField
						select
						size="small"
						variant="outlined"
						// defaultValue="EUR"
						SelectProps={{
							native: true,
						}}
						sx={{
							width: '70px',

							'& select': {
								textAlign: 'center',
								height: '20px',
								padding: '2px 0',
								fontSize: '.8rem',
							},
						}}
						disabled={createDiscountItem.previousDiscounts || createDiscountItem.previousReturns}
						onChange={(e) => setSelectedCurrency(e.target.value)}
						value={selectedCurrency}
					>
						{currencies.map((option) => (
							<option key={option} value={option}>
								{option}
							</option>
						))}
					</TextField>
				</>
			</Box>
		</Box>
	);
};
